module.exports = __webpack_public_path__ + "static/media/Darchviz 06.452cd047.jpg";